
import CTAButton from "@/components/CTAButton.vue";
export default {
    name: "ContactCTAButtons",
    components: {
        CTAButton
    },
    data() {
        return {
            ready: false
        };
    },
    mounted() {
        setTimeout(() => {
            this.ready = true;
        }, 200);
    }
};
